export default __webpack_public_path__ + "static/media/slider1.43794fa2.jpg";